import React, { Component, Fragment, useEffect } from 'react';
import { elements } from './_data_safety_layout';
import DaySafetyElement from './DaySafetyElement';
import '@app/components/sqdp/int/styles/safety-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood, getDayColorWarn } from '@app/services/localStorage.service';

class SafetyLayout extends Component {
  // constructor(){
  //   this.childSetClickedFunc = React.useRef(null)
  // }
  state = {
    showInfo: false,
    element: {},
    // items: []
    // lastClickedElement: 0
  };

  showInfo = (num) => {
    //reset previous clicked button
    // if(this.state.lastClickedElement != 0){
    //   // this.state.items[this.state.lastClickedElement].setClicked(false);
    //   this.childSetClickedFunc.current();
    // }
    // this.state.lastClickedElement = num;
    this.props.showIssueInfo(num, 1, 'int');
  };
  // getColorOfDay = (issueOfDay, dateNum) => {
  //   if(issueOfDay){

  //     if(issueOfDay.isRestDay){
  //       // if(issueOfDay.countDeliveryTotal <=0 && issueOfDay.countProductivityTotal <=0 && issueOfDay.countQualityTotal <=0){
  //         return 'emtpy_state'
  //     }

  //     if(!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <=0){
  //       // console.log('datenum and dayjs ', dateNum,   dayjs().get('date'))

  //       let today = dayjs();
  //       let selectedTime = dayjs(this.props.selectedMonth)
  //       // console.log('today month and year  ', today.get('month'),  today.get('year'))
  //       // console.log('selectedTime month and year  ', selectedTime.get('month'),  selectedTime.get('year'))
  //       if( today.get('month') <= selectedTime.get('month') && today.get('year') <= selectedTime.get('year') && dateNum == today.get('date')){
  //         return 'emtpy_state';
  //       }

  //       return 'green_state';
  //     }

  //     if(!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident<=0){
  //       return 'yellow_state';
  //     }

  //     if(issueOfDay.countSafetyIsAccident > 0){
  //       return 'red_state';
  //     }
  //   }

  //   return 'emtpy_state';
  // }

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }

      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <= 0) {
        return 'green_state';
      }

      if (!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countSafetyIsAccident > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  // closeInfo = () => {
  //   this.props.setState({ showInfo: false, element: {} })
  // }

  /**
   * Helper method that will generate a number of elements
   * from start index to end index to avoid copy pasting
   * all the hundred elements
   * @param {number} start
   * @param {number} end
   * @return {Array<Object>}
   */
  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DaySafetyElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          color={color}
          num={i}
          issues={issueOfDay ? issueOfDay : {}}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-safety">
          {/* Elements 1-4 */}
          {this.populateElements(1, 32)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>=>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        <h3 className="center" style={{ marginTop: '20px' }}>
          Safety
        </h3>
      </>
    );
  }
}

export default SafetyLayout;
